<script setup>
import CLink from "@/Components/CLink.vue"
import {computed, ref} from "vue"
import {usePage} from "@inertiajs/vue3";

const page = usePage()
const props = defineProps({
    product: Object
})

const showSidebar = ref(false)
const hoveredImage = ref(null)
const hoveredColor = ref(null)

// relativo ao filtro de cor, se ativo
const activeAttributeColorsId = computed(() => page.props.attributeColorsIds || [])
const firstVariantWithActiveColor = computed(() => props.product.colors.find((colorObject) => {
    return activeAttributeColorsId.value.includes(parseInt(colorObject.attribute_value_id))
}))
const mainImage = computed(() => {
    if (firstVariantWithActiveColor.value) {
        // quando um filtro de cor estiver ativo, exibimos a foto de uma variação daquela cor
        return firstVariantWithActiveColor.value.media_url
    } else if (props.product.medias.length > 0) {
        return props.product.medias[0].url
    } else if (props.product.colors.length > 0) {
        return props.product.colors[0].media_url
    } else {
        return '/assets/img/no-photo.png'
    }
})
const productLink = computed(() => {
    return firstVariantWithActiveColor.value ? route('product.viewColorVariation', {product: props.product, colorAttribute: firstVariantWithActiveColor.value.attribute_value}) : null
})
</script>

<template>
    <v-card class="pa-4 infos overflow-visible" outlined :style="{height: '375px', 'max-width': '350px'}"
            @mousemove="showSidebar = true" @mouseleave="showSidebar = false">
        <v-row class="position-relative" justify="center" align="center">
            <v-col>
                <c-link :href="productLink ? productLink : route('product.view', product)">
                    <v-img :src="hoveredImage || mainImage" alt="Imagem do Produto" style="height: 216px" eager>
                        <template v-slot:placeholder>
                            <div class="d-flex align-center justify-center fill-height">
                                <v-progress-circular color="grey-lighten-4" indeterminate/>
                            </div>
                        </template>
                    </v-img>
                    <v-card-title class="pb-0">
                        {{ product.title }}
                    </v-card-title>
                    <v-card-subtitle>
                        {{ product.reference }} {{ hoveredColor ? '(' + hoveredColor + ')' : firstVariantWithActiveColor ? '(' + firstVariantWithActiveColor?.title + ')' : ''}}
                    </v-card-subtitle>
                    <v-card-text>
                        <p class="w-100 three-line-truncate" >{{ product.description }}</p>
                    </v-card-text>
                </c-link>
            </v-col>
            <v-slide-x-transition>
                <v-col md="3" class="position-absolute" style="right: -15px; top: 2%"
                       v-if="!$vuetify.display.mobile && showSidebar && product.colors.length > 1">
                    <v-card elevation="3">
                        <v-slide-group show-arrows direction="vertical" prev-icon="mdi-chevron-up" next-icon="mdi-chevron-down" style="max-height: 300px">
                            <v-slide-group-item v-for="color in product.colors" :key="color.media_url">
                                <c-link :href="route('product.viewColorVariation', {product, colorAttribute: color.attribute_value})"
                                        @mouseover="hoveredImage = color.media_url; hoveredColor = color.title"
                                        @mouseleave="hoveredImage = hoveredColor = null">
                                    <v-img :src="color.media_url" class="my-1" style="min-height: 50px" eager>
                                        <template v-slot:placeholder>
                                            <div class="d-flex align-center justify-center fill-height">
                                                <v-progress-circular color="grey-lighten-4" indeterminate/>
                                            </div>
                                        </template>
                                    </v-img>
                                </c-link>
                            </v-slide-group-item>
                        </v-slide-group>
                    </v-card>
                </v-col>
            </v-slide-x-transition>
        </v-row>
    </v-card>
</template>

<style>
.three-line-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
}
</style>
